import { Prettify } from '@nucleus/lib-type-utils';
import { nucleusClass } from '@nucleus/web-theme-elements';
import classNames from 'classnames';
import { omit as _omit } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { InfoContent } from '../blocks/Base';
import { BlockMedia } from '../blocks/BlockMedia';
import { BlockBackground } from '../components/Background';
import { BlockLayoutProps } from '../types/component';

export const BlockLayout = (props: BlockLayoutProps): JSX.Element => {
  const innerProps = _omit(props, ['name', 'height']);

  return (
    <StyledBlockLayout {...innerProps} className={classNames([nucleusClass('blocks'), innerProps.className])}>
      <BlockBackground background={props.blockBackgroundMedia} />
      {props.children}
    </StyledBlockLayout>
  );
};

const StyledBlockLayout = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  width: 100%;

  position: relative;
  z-index: 0;

  ${InfoContent} {
    position: relative;
    z-index: 1;
  }

  ${BlockMedia} {
    z-index: 1;
  }
`;

export const blockLayoutInnerProps = <T extends BlockLayoutProps>(props: T): Prettify<Omit<T, 'className'>> => {
  // className is not something we want to propagate down.
  // blocks are only meant to be read below the section layout level.
  return { ..._omit(props, ['className']), blocks: [] };
};
